import { render, staticRenderFns } from "./render-image.vue?vue&type=template&id=2f134f2a&"
import script from "./render-image.vue?vue&type=script&lang=js&"
export * from "./render-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports